import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { FeatureProvider } from "@/context/FeatureContext";
import { ProtectedRoute, RootRedirect } from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AcceptInvite from "@/pages/AcceptInvite";
import Dashboard from "@/pages/Dashboard";
import UserManagement from "@/pages/UserManagement";
import SuperAdminConsole from "@/pages/SuperAdminConsole";
import FranchisePortal from "@/pages/FranchisePortal";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <FeatureProvider>
            <Routes>
              <Route path="/" element={<RootRedirect />} />
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/accept-invite" element={<AcceptInvite />} />
              <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute adminOnly><SuperAdminConsole /></ProtectedRoute>} />
              <Route path="/franchise" element={<ProtectedRoute franchiseOnly><FranchisePortal /></ProtectedRoute>} />
              <Route path="/users" element={<ProtectedRoute adminOnly><UserManagement /></ProtectedRoute>} />
            </Routes>
            <Toaster position="top-right" />
          </FeatureProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
